import { useIntl } from "@leagueplatform/locales";
import { usePageViewAnalytics } from "@leagueplatform/analytics";
import { useDocumentTitle } from "@leagueplatform/web-common";
import { HealthJourneyRoutes } from "components/lazy-routes.component";
import { JourneyContentWrapper } from "components/journey-content-wrapper.component";
import { PageContentWrapper } from "components/page-content-wrapper.component";
import { PageHeader } from "components/page-header/page-header.component";

export const HistoryPage = () => {
  usePageViewAnalytics({ screen_name: "History" });
  const { formatMessage } = useIntl();
  const historyTitle = formatMessage({ id: "STR_HISTORY" });
  useDocumentTitle(historyTitle);

  return (
    <PageContentWrapper>
      <PageHeader
        variant="sub-page"
        mobileBand="none"
        headingText={historyTitle}
      />
      <JourneyContentWrapper
        css={{
          ".cc-page-header-background": { display: "none" },
          "& :has(> .cc-page-header-background)": { padding: 0 },
        }}
      >
        <HealthJourneyRoutes />
      </JourneyContentWrapper>
    </PageContentWrapper>
  );
};
